window?.varify?.helpers?.isInView("[data-varify-test='cta_carousel']", (element) => {
  window?.dataLayer?.push({
    event: "cta_viewed",
    cta_variant: element.dataset.varifyVariantName || "hover",
  });
});

window?.varify?.helpers?.onDomChanged(() => {
  document.querySelectorAll("product-item .js-atc-button").forEach((cta) => {
    const varifyVariant = cta.closest("[data-varify-test]")?.dataset.varifyVariantName;
    if (varifyVariant) {
      cta.onclick = () => {
        window.dataLayer.push({
          event: "cta_clicked",
          cta_variant: varifyVariant || "hover",
        });
      };
    }
  });
});